/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Carrier_TitleInputs */

const vi_shipping_carrier_title = /** @type {(inputs: Shipping_Carrier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị vận chuyển`)
};

/**

* @param {Shipping_Carrier_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier_title = /** @type {((inputs?: Shipping_Carrier_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Carrier_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier_title(inputs)
});